import { render, staticRenderFns } from "./SimpleHierarchy.vue?vue&type=template&id=0deac167&"
import script from "./SimpleHierarchy.vue?vue&type=script&lang=js&"
export * from "./SimpleHierarchy.vue?vue&type=script&lang=js&"
import style0 from "./SimpleHierarchy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports